module.exports = __webpack_public_path__ + "img/thumbnail_Gemsbok_m_normal.7f6896cb.png";